import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var FreelancerService = /** @class */ (function () {
    function FreelancerService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    FreelancerService.prototype.getAssignedFreelancers = function (storeId) {
        var url = environment.apiBase + ("stores/" + storeId + "/popup_freelancers?assigned=false");
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancerService.prototype.getAllFreelancers = function () {
        var url = environment.apiBase + "freelancers";
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancerService.prototype.getFreelancers = function (id) {
        var url = environment.apiBase + ("freelancers/" + id);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancerService.prototype.getApprovedFreelancers = function (storeId) {
        var url = environment.apiBase + ("stores/" + storeId + "/popup_freelancers?assigned=true");
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancerService.prototype.updateApprovedFreelancers = function (body) {
        var url = environment.apiBase + ("stores/" + body.storeId + "/popup_freelancers");
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body.approved, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return FreelancerService;
}());
export { FreelancerService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/freelancer.service.ts.pre-build-optimizer.js